import { render, staticRenderFns } from "./consudoc.vue?vue&type=template&id=2dc79d82&scoped=true"
import script from "./consudoc.vue?vue&type=script&lang=js"
export * from "./consudoc.vue?vue&type=script&lang=js"
import style0 from "./consudoc.vue?vue&type=style&index=0&id=2dc79d82&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc79d82",
  null
  
)

export default component.exports